class Pricechanges {
  constructor () {
    this.form = document.querySelector('.pricechange-form');
    this.filters = document.querySelectorAll('.filter__options input[data-search-filter]');
    [...this.filters].forEach(filter => filter.addEventListener('click', this.getFilterValue.bind(this)));
    this.selectedValue = null;
    this.checkSelectedLabel();
  }

  getFilterValue (e) {
    this.labelsUpdate(e.target);
    this.selectedValue = e.target.value;
    this.SubmitForm();
  }

  checkSelectedLabel () {
    [...this.filters].forEach(filter => {
      if (filter.checked === true) filter.parentElement.classList.add('selected');
    });
  }

  labelsUpdate (label) {
    [...this.filters].forEach(filter => filter.parentElement.classList.remove('selected'));
    label.parentElement.classList.add('selected');
  }

  SubmitForm () {
    this.form.submit(this.selectedValue);
  }
}

if (document.querySelector('.pricechange-form')) {
  window.priceChanges = new Pricechanges();
};
